module.exports = {
  VUE_APP_ENC: 'U2FsdGVkX1+4rZfJSoc2Ty/fgDPHpLEDDX3nLLDNMQk=',
  VUE_APP_API_HOST:
    'U2FsdGVkX19JZmaPnw5opNUUxoNH02ezmsinUcZDmSJ5WfDPrjy1TbodnhmfLe9Tr+57LJTFh0VW+vCnqyvZsA==',
  VUE_APP_GOOGLE_MAP_API_KEY:
    'U2FsdGVkX1+n0Zsu0AmDznsKeymUdpM+RYeVv4rU5d3N9Exe5yNFnyCkHR49tj+v4fXR/9MPsgPY4brWlNlOiA==',
  VUE_APP_GEOIP_API_KEY: 'U2FsdGVkX1/Ly91TRWcUJqvw7M/gpbLumFFGxxgtmpg=',
  VUE_APP_S3D_CLOUDFRONT_ID: 'U2FsdGVkX1+/j3KJSborAdBwuBzUSGHqVs1mte3uMg4=',
  VUE_APP_S3D_BUCKET:
    'U2FsdGVkX188wExJk7C8TKpIoCCUfehiwZ6naxlMcGphGIs6htuCCT6XJU5aBjt01+QUh6AM3IoCtBBmlACr5g==',
  VUE_APP_SENDGRID_API_KEY:
    'U2FsdGVkX1+miCQFaMVoSiU4LQycRIieDiSJ+A71pG0L07ouymFg8/dkIDa+EAb1OCYzVmvehpw4t7JZGOPrTiDwseYxIOdRS8RQuwlpsfd+62T7Ma8jR/N5tvt1CHJF',
  VUE_APP_MAILCHIMP_API_KEY:
    'U2FsdGVkX1+pz7LyUsgmLPHlC5fH0okgTm2ou/UVRgX/aIlARulDHJ9XJsi0xqUUasFt7fc/8W6HerrT2OD7eg==',
  VUE_APP_GRAPHQL_AUTH:
    'U2FsdGVkX19jRR8sVpcgcTQjaSvc+A9pEafOZxOY15ORxR5A5etwCW73Zq/RqOTy',
  BASE_PDF_DL_URL:
    'U2FsdGVkX1/JmOW6X7ByD0VsXXVjYMyUvd6XLuRNadXxUhLumvQUyFnfCIgh3qW5sggUYPkNpd8NNAaLMfWv7AhsaaiIFuXR9a8P8nuSNZwLBl3wiFqLeiWmxWNWZUGc'
}
